import { isFinanceProject, isGlobalProject } from 'config';

export const getClientContactsAndAddressesFormSectionKeys = (): string[] => {
  if (isGlobalProject()) {
    return ['residentialAddress', 'contacts', 'orderSubmissionContacts'];
  }

  if (isFinanceProject()) {
    return [
      'residentialAddress',
      'registrationAddress',
      'contacts',
      'orderSubmissionContacts',
    ];
  }

  return [];
};
